<div *ngIf="indiceRemissivo.permissoes.length > 0">
    <h3>{{indiceRemissivo.letra}}</h3>
    
    <ul>
        <li *ngFor="let p of indiceRemissivo.permissoes">
            
            <p class="form-check form-switch">
                <input class="form-check-input" type="checkbox" 
                (change)="handleCheckboxChange(p, $event)" 
                [checked]="p.selecionado"
                [disabled]="modoVisao"
                value="{{p.selecionado}}">
                <span [innerHTML]="formatarCaminhoLongo(p)"></span>
            </p>
        </li>
    </ul>
</div>

